import { defineComponent as _defineComponent } from 'vue'
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import { computed, ref, watch } from 'vue';
import { useDebounce } from '@vueuse/core';
import { BcxFormField } from '@/models/BcxForm';
import useUser from '@/mixins/useUser';
import MeetingSectionItem from '@/components/meeting-scheduler/components/MeetingSectionItem.vue';
import MeetingSection from '@/components/meeting-scheduler/components/MeetingSection.vue';
import useMeetingScheduler from '@/components/meeting-scheduler/composables/useMeetingScheduler';
import dayjs from 'dayjs';
import { MeetingOverview } from '@/models/MeetingScheduler';
import MeetingLoading from '@/components/meeting-scheduler/components/MeetingLoading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingSearch',
  setup(__props) {

const { tUserFallback: t } = useUser('self');
const {
  searchResults, fetchSearchMeetings, isSearchLoading, refreshCalendar, showMeeting
} = useMeetingScheduler();

function onSelectResult(item: MeetingOverview) {
  showMeeting(item, new Date(item.start));
  refreshCalendar();
}

const field = computed<BcxFormField[]>(() => [
  {
    name: 'searchQuery',
    width: '100%',
    label: t('meeting.search.form.meeting-search'),
    type: 'text',
    textOptions: { showX: true }
  }
]);

const searchQuery = ref({
  searchQuery: ''
});

const groupedResults = computed(() => {
  if (!searchResults.value) return [];
  return searchResults.value.reduce((groups, item) => {
    const day = dayjs(item.start).format('DD.MM.YYYY');
    const group = groups.find((g) => g.day === day);
    if (group) {
      group.meetings.push(item);
    } else {
      groups.push({ day, meetings: [item] });
    }
    return groups;
  }, [] as { day: string; meetings: MeetingOverview[] }[]);
});

const debouncedQuery = useDebounce(computed(() => searchQuery.value.searchQuery), 250);

watch(debouncedQuery, (newQuery) => {
  if (newQuery.length >= 1) fetchSearchMeetings(newQuery);
  else searchResults.value = null;
});

return { __sfc: true,t, searchResults, fetchSearchMeetings, isSearchLoading, refreshCalendar, showMeeting, onSelectResult, field, searchQuery, groupedResults, debouncedQuery, BCXForm, MeetingSectionItem, MeetingSection, MeetingLoading }
}

})